/**
 * Modal composable for vue-js-modal
 * @see https://github.com/euvl/vue-js-modal
 */
import { getCurrentInstance } from 'vue'

export function useModal() {
    const instance = getCurrentInstance()
    return {
        show: name => instance?.proxy?.$modal?.show(name),
        hide: name => instance?.proxy?.$modal?.hide(name),
    }
}
